/**
 * @module Split Section - Image + Content
 * @description Split Section 50/50
 */
import DynamicButton from "@/blocks/Buttons/DynamicButton";
import PropTypes from "prop-types";
import Tooltip from "@/blocks/Tooltip";
import styles from "./index.module.css";

const defaultItems = [
  <>
    No data caps or overage charges
    <Tooltip disclosure="data-caps" />
  </>,
  "No long-term contracts",
  <>
    Amazon eero Wi-Fi router included
    <span key="span-1" data-legal="eero" />
  </>,
];

const position = "SPLIT SECTION PRICE COPPER";

/**
 * @function Component
 * @description
 */
const Component = ({ ...props }) => {
  const {
    title = "Work, learn, and live connected",
    items = defaultItems,
    theme,
  } = props;

  return (
    <section className={`component ${styles.component}`}>
      <div className="l-container">
        <div className={"g-row g-row--match-height "}>
          <div className="g-col g-col--one-half">
            <div className={`${styles.component__contentWrapper}`}>
              <div>
                <div className={`h5 ${styles.component__productTitle}`}>
                  Frontier<sup>&reg;</sup> Internet
                </div>

                <div className={styles.component__productInfo}>
                  <div className={styles.component__productPricing}>
                    <div className={styles.component__productPrice}>
                      <span className="h1 h1--pricepoint">
                        $64.99
                        <sup className={styles.component__productPricingLegal}>
                          <span
                            key="span-1"
                            data-legal="copper-new-residential"
                          />
                        </sup>
                      </span>
                      <div className={styles.component__productLockup}>
                        <s className={styles.component__product_priceStrike}>
                          $74.99
                        </s>
                      </div>
                    </div>
                  </div>
                </div>

                <p className={`legal ${styles.component__shortLegal}`}>
                  per month w/ Auto Pay and Paperless Bill. One-time charges
                  apply.
                </p>
              </div>
            </div>
          </div>

          <div className="g-col g-col--one-half">
            <div className={`${styles.component__content} `}>
              <h4 className={`component__title ${styles.component__title}`}>
                {title}
              </h4>

              <ul className={styles.component__list}>
                {items.map((item, index) => (
                  <li key={index}>
                    <span
                      className={`icon icon-checkmark1 ${styles.component__icon} ${theme && styles[`component__icon__${theme}`]}`}
                    />
                    {item}
                  </li>
                ))}
              </ul>

              <DynamicButton type="cart" position={position} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Component.propTypes = {
  title: PropTypes.node,
  items: PropTypes.arrayOf(PropTypes.node),
  isDark: PropTypes.bool,
};

export default Component;
